"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _Delete = _interopRequireDefault(require("@mui/icons-material/Delete"));

var _style = _interopRequireDefault(require("./style"));

var _isEmail = _interopRequireDefault(require("validator/lib/isEmail"));

var _map = _interopRequireDefault(require("lodash/map"));

var _findIndex = _interopRequireDefault(require("lodash/findIndex"));

var _react2 = require("@emotion/react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Modal = ({
  openModal,
  handleClose,
  eliminarEmail,
  idEmail
}) => {
  return (0, _react2.jsx)(_material.Dialog, {
    open: openModal,
    onClose: handleClose,
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description"
  }, (0, _react2.jsx)(_material.DialogContent, null, (0, _react2.jsx)(_material.DialogContentText, {
    id: "alert-dialog-description"
  }, "\xBFEst\xE1 seguro/a que desea eliminar este email?")), (0, _react2.jsx)(_material.DialogActions, null, (0, _react2.jsx)(_material.Button, {
    onClick: handleClose,
    css: _style.default.colorCeleste,
    color: "primary"
  }, "Cancelar"), (0, _react2.jsx)(_material.Button, {
    onClick: () => eliminarEmail(idEmail),
    css: _style.default.colorCeleste,
    color: "primary",
    autoFocus: true
  }, "Aceptar")));
};

class FormEmails extends _react.default.Component {
  constructor(props) {
    super(props);
    this.setInput = this.setInput.bind(this);
    this.agregarInput = this.agregarInput.bind(this);
    this.perdioFoco = this.perdioFoco.bind(this);
    this.agregaEmail = this.agregaEmail.bind(this);
    this.eliminaEmail = this.eliminaEmail.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.eliminar = this.eliminar.bind(this);
    this.state = {
      mostrando: [],
      newInput: false,
      emails: this.props.emails ? this.props.emails : [],
      openModal: false,
      idEmail: null
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.emails != this.props.emails) {
      this.setState({
        emails: this.props.emails
      });
    }
  }

  setInput() {
    this.inputEmail.value = '';
    this.inputEmail.focus();
  }

  agregarInput() {
    this.setState({
      newInput: true
    }, this.setInput());
  }

  perdioFoco(input) {
    this.setState({
      newInput: false
    }, this.agregaEmail(input));
  }

  agregaEmail(event) {
    let emailsAEditar = this.state.emails;
    const value = event.target.value;
    const existe = (0, _findIndex.default)(emailsAEditar, e => e.email === email) !== -1;

    if (value && !existe && (0, _isEmail.default)(value)) {
      const email = {
        id: "new" + ("" + Math.random()).substring(2, 10),
        email: value
      };
      this.props.onChange(0, email);
    }
  }

  eliminaEmail(id) {
    this.setState({
      openModal: true,
      idEmail: id
    });
  }

  handleClose() {
    this.setState({
      openModal: false,
      idEmail: null
    });
  }

  eliminar(id) {
    let emails = this.state.emails;
    const emailAEliminar = emails.find(email => email.id == id);
    let emailConDelete = { ...emailAEliminar,
      delete: 1
    };
    this.props.onChange(2, emailConDelete);
    this.setInput();
    this.handleClose();
  }

  render() {
    const {
      newInput,
      emails,
      openModal
    } = this.state;
    return (0, _react2.jsx)("div", {
      css: _style.default.emailContainer
    }, (0, _react2.jsx)(_material.Collapse, {
      in: !!emails.length
    }, (0, _react2.jsx)(_material.List, null, (0, _map.default)(emails, (email, index) => {
      return (0, _react2.jsx)(_material.ListItem, {
        key: index,
        disableGutters: true
      }, (0, _react2.jsx)(_material.ListItemText, {
        css: _style.default.anfitrionEmail,
        primary: email.email
      }), (0, _react2.jsx)(_material.ListItemSecondaryAction, null, (0, _react2.jsx)(_material.Button, {
        onClick: () => this.eliminaEmail(email.id),
        css: _style.default.deleteButton
      }, (0, _react2.jsx)(_Delete.default, null))));
    }))), (0, _react2.jsx)(Modal, {
      classes: _style.default,
      openModal: openModal,
      handleClose: this.handleClose,
      eliminarEmail: this.eliminar,
      idEmail: this.state.idEmail
    }), (0, _react2.jsx)(_material.Collapse, {
      in: newInput || !emails.length
    }, (0, _react2.jsx)(_material.FormControl, {
      fullWidth: true,
      css: _style.default.inputEmail,
      "aria-describedby": "email-text"
    }, (0, _react2.jsx)(_material.Input, {
      inputRef: inputEmail => {
        this.inputEmail = inputEmail;
      },
      id: "email",
      type: "email",
      onBlur: event => this.perdioFoco(event),
      placeholder: "Emails donde recibir las consultas"
    }))), (0, _react2.jsx)("div", {
      css: _style.default.ButtonDerecha
    }, (0, _react2.jsx)(_material.Button, {
      onClick: this.agregarInput,
      css: _style.default.colorCeleste,
      size: "small",
      color: "primary"
    }, newInput ? '+ Agregar' : '+ Agregar otro e-mail')));
  }

}

var _default = FormEmails;
exports.default = _default;